import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { usePromiseTracker } from "react-promise-tracker";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { Spinner } from "./stories/es/Spinner/Spinner";

const LoadingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();

  return promiseInProgress && <Spinner />;
};
i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [
      "en",
      "zh",
      "zh-TW",
      "fr",
      "de",
      "hi",
      "bn",
      "es",
      "ja",
      "vi",
      "th",
      "ar",
      "ru",
      "pt",
      "it",
      "uk",
    ],
    fallbackLng: "en",
    debug: false,
    // Options for language detector
    detection: {
      order: ["cookie", "navigator", "htmlTag", "path"],
      caches: ["cookie"],
      cookieMinutes: 525600,
      cookieOptions: { path: "/", sameSite: "strict" },
    },
    // react: { useSuspense: false },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
  });
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
        <LoadingIndicator />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
